module.exports = __webpack_public_path__ + "img/team2.5fe390ba.jpg";